import createValueModule from "@/redux/create-value-module";

import { $ImageViewerModuleName, TImageViewerState } from "./imageViewer.types";

const { constants: _constants, actions } = createValueModule<TImageViewerState>(
    $ImageViewerModuleName,
    {
        activeIndex: 0
    }
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
